import Section from '@components/atoms/Section';
import Spacing from '@components/atoms/Spacing';
import { Heading1, Paragraph } from '@components/atoms/Typography';
import GridLinkList from '@components/molecules/list/GridLinkList';
import PageContainer from '@components/molecules/PageContainer';
import BREAKPOINTS from '@lib/constants/breakpoints';
import env from '@lib/constants/env';
import ROUTES from '@lib/constants/routes';
import motorcycleStats from '@lib/helpers/motorcycleStats';
import { GetStaticProps } from 'next';
import { BreadcrumbJsonLd } from 'next-seo';
import { useRouter } from 'next/router';
import React from 'react';
import styled from 'styled-components';

interface Props {
  brands: string[];
}

const Header = styled(Section)`
  padding-top: 120px;

  @media screen and (max-width: ${BREAKPOINTS.medium}) {
    padding-top: 50px;
  }
`;

const Stats = ({ brands }: Props) => {
  const router = useRouter();

  if (router.isFallback) return <PageContainer loading />;

  console.log(brands);

  return (
    <PageContainer
      title="Marcas - Ficha técnica | Luna"
      metaDescription="Base de dados de ficha técnica para veículos motorizados. Informações como potência, especificações técnicas, economia, valor do seguro e mais."
    >
      <BreadcrumbJsonLd
        itemListElements={[
          {
            position: 1,
            name: 'Luna',
            item: env.baseUrl,
          },
          {
            position: 2,
            name: 'Ficha técnica',
            item: `${env.baseUrl}${ROUTES.stats}`,
          },
        ]}
      />
      <Header>
        <Heading1>Fichas técnicas das Marcas de Moto</Heading1>
        <Spacing top={2}>
          <Paragraph>
            Escolha a marca para ver as fichas técnicas disponíveis
          </Paragraph>
        </Spacing>
      </Header>
      <Section>
        <GridLinkList
          links={brands.map((brand) => ({
              label: brand.replace(/_/g, ' '),
              path: ROUTES.brandStats(brand),
            }))}
        />
      </Section>
    </PageContainer>
  );
};

export const getStaticProps: GetStaticProps<Props> = async () => {
  const brands = await motorcycleStats.getBrands();

  return {
    props: {
      brands,
    },
  };
};

export default Stats;
